import {IExternalCode} from "./i-external-code";

export class ExternalCode {
    public constructor(public type: string,
                       public value: string) {
    }

    public static fromInterface(iExternalCode: IExternalCode): ExternalCode {
        return new ExternalCode(iExternalCode.type, iExternalCode.value);
    }
}
